import React from 'react'
import { Button, Form, Modal, Select } from 'antd'

const CategorySelectorModal = ({ showModal, onChancel, onFinish, categories }) => {
  const [form] = Form.useForm()

  const onChancelClick = () => {
    onChancel()
    form.resetFields()
  }

  const onFinishCallback = ({ category }) => {
    onFinish(category)
    form.resetFields()
  }

  return (
    <Modal
      title="Выбрать категорию"
      visible={showModal}
      onCancel={onChancelClick}
      footer={[
        <Button key="back" onClick={onChancelClick}>
          Отмена
        </Button>,
        <Button key="save" type="primary" onClick={() => form.submit()}>
          Обновить
        </Button>,
      ]}
    >
      <Form
        name="choose-category"
        initialValues={{ remember: true }}
        autoComplete="off"
        layout="vertical"
        onFinish={onFinishCallback}
        form={form}
        size="large"
      >
        <Form.Item name="category" rules={[{ required: true, message: 'Обязательно поле' }]}>
          <Select
            style={{ flex: 1 }}
            options={categories.map((category) => ({
              value: category,
              label: category,
            }))}
            placeholder="Выберите новую категорию"
            dropdownMatchSelectWidth={false}
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default CategorySelectorModal
